import { useLocalSearchParams, useRouter } from 'expo-router';

import { Bounded } from '@/components/ui/Bounded';
import { Button } from '@/components/ui/Button';
import { NavBar } from '@/components/ui/NavBar';
import { Screen } from '@/components/ui/Screen';
import { Text } from '@/components/ui/Text';
import { useGoBack } from '@/lib/navigation';

export default function CheckEmailScreen() {
  const router = useRouter();
  const goBack = useGoBack('/sign-in');
  const { email } = useLocalSearchParams<{ email?: string }>();

  return (
    <Screen edges={['top']}>
      <NavBar onBack={goBack} />
      <Bounded className="flex-1 items-center justify-center gap-4 px-8">
        <Text className="text-6xl">✉️</Text>
        <Text variant="title" className="text-center">
          Check your email
        </Text>
        <Text variant="subtitle" className="text-center">
          We sent a reset link to {email ?? 'your inbox'}. Tap it to set a new password.
        </Text>
        <Button
          variant="ghost"
          label="Back to sign in"
          onPress={() => router.replace('/sign-in')}
        />
      </Bounded>
    </Screen>
  );
}
